export const GET_CATEGORY_SUCCESS = "CATEGORY/GET_CATEGORY_SUCCESS";

export function getCategorySuccess(category) {
  return {
    type: GET_CATEGORY_SUCCESS,
    payload: {
      category
    }
  }
}

export function getCategory(params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise ((resolve, reject) => {
      ecommerce.Basic.getCategory(params)
        .then(r => {
          const nodes = r.data.nodes

          dispatch(getCategorySuccess(nodes))

          resolve(nodes)
        })
        .catch(e => {
          reject(e)
        })
    })
  }
}

export default function reducer(
  state = {
    category: []
  },
  { type, payload }
) {
  switch (type) {
    case GET_CATEGORY_SUCCESS:
      return Object.assign({}, state, {
        category: payload.category
      })

    default:
      return state;
  }
}